import axios from "axios";
import { AuthService } from "@/common/api.service";
import { AUTH_LOGIN, AUTH_REGISTER, AUTH_LOGOUT } from "./actions.type";
import {
  AUTH_LOGGEDIN,
  AUTH_LOGOUT_SUCCESS
} from "./mutations.type";

const state = {
  token: localStorage.getItem("token") || null,
  user: {}
};

const getters = {
  isLoggedIn: state => !!state.token
};

// TODO: Actions are not used
const actions = {
  async [AUTH_LOGIN]({ commit }, { email, password }) {
    return AuthService.login(email, password)
      .then((response) => {
        commit(AUTH_LOGGEDIN, response);
      })
      .catch(error => {
        localStorage.removeItem("token");
        throw new Error(error);
      });
  },
  async [AUTH_REGISTER]({ commit }, { email, password }) {
    return AuthService.register(email, password)
      .then(data => {
        commit(AUTH_LOGGEDIN, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [AUTH_LOGOUT]({ commit }) {
    commit(AUTH_LOGOUT_SUCCESS);
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["Authorization"];
  }
};

const mutations = {
  [AUTH_LOGGEDIN](state, token) {
    state.token = `Bearer ${token}`;
    localStorage.setItem("token", state.token);
    axios.defaults.headers.common["Authorization"] = state.token;
  },
  // TODO: not used
  [AUTH_LOGOUT_SUCCESS](state) {
    state.user = {};
    state.token = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
